import { KoukyuuService } from "@/service/KoukyuuService"

export function useDelete() {
  const srv = new KoukyuuService()

  const torikeshi = async(koukyuuId: number) => {
    const res = await srv.delete(koukyuuId).then(res => {
      return res
    })
    return res
  }

  return {
    koukyuuDelete: torikeshi,

  }
}
